export enum StudyReelHostNames {
  SendCredentials = 'com.crossover.native_messaging_host',
  BatteryStatus = 'com.crossover.battery_status',
  Restart = 'com.crossover.restart_app',
  Uuid = 'com.crossover.uuid',
  Heartbeat = 'com.crossover.heartbeat',
  LocalLogging = 'com.crossover.local_logging'
}
